import { useQuery } from "@tanstack/react-query";
import type { Environment } from "../../../types";
import { getApiBase } from "../../../lib/remote-config";
import type { RewardFactoryInfoResponse } from "../types";

export const REWARD_FACTORY_INFO_QUERY_KEY = "wp:reward-factory-info";

export function useRewardFactoryInfo(env: Environment, enabled = true) {
  const { data, ...rest } = useQuery<RewardFactoryInfoResponse>({
    queryKey: [REWARD_FACTORY_INFO_QUERY_KEY, env],
    queryFn: async ({ signal }) => {
      const baseUrl = await getApiBase("gameReward", env);
      const res = await fetch(`${baseUrl}/v1/factory/info`, {
        cache: "no-store",
        signal,
      });
      if (!res.ok) throw new Error(`Factory info fetch failed: ${res.status}`);
      const json: RewardFactoryInfoResponse = await res.json();
      if (json.code !== 200) {
        throw new Error(`Factory info API error: ${json.code}`);
      }
      return json;
    },
    enabled,
    staleTime: 0,
  });

  return {
    factoryInfo: data?.data ?? null,
    routerAddress: data?.data.router_address ?? "",
    ...rest,
  };
}
